import { render, staticRenderFns } from "./AlgoliaCheckbox.vue?vue&type=template&id=66c313b0&scoped=true&"
import script from "./AlgoliaCheckbox.vue?vue&type=script&lang=js&"
export * from "./AlgoliaCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c313b0",
  null
  
)

export default component.exports